import { ContactPreferences } from '@features/ForestOwner/Search/Overview/ContactPreferences'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/forestowner/$forestownerId/contactpreferences/')({
  component: ContactPreferences,
  staticData: {
    breadcrumb: 'Kontaktpreferanser',
  },
})
